import { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

interface useScrollDirectionByElementProps {
	showOnTop?: boolean;
	targetRef: HTMLElement | null;
	threshold?: number;
	checkOnTop?: boolean;
}

export const useScrollDirectionByElement = ({
	targetRef,
}: useScrollDirectionByElementProps) => {
	const [scrollDirection, setScrollDirection] = useState<
		"up" | "down" | "on-top"
	>("on-top");

	const { pathname } = useLocation();
	const prevScrollY = useRef<number>(0);
	const prevScrollHeight = useRef<number>(0);
	const shouldApplyHeaderClass = useRef<boolean>(true);
	function setShouldApplyHeaderClass(flag: boolean) {
		shouldApplyHeaderClass.current = flag;
	}
	const handleScroll = () => {
		if (!shouldApplyHeaderClass.current) {
			return;
		}
		if (targetRef != null) {
			const currentScrollY = targetRef.scrollTop;
			const currentScrollHeight = targetRef.scrollHeight;
			const isOnTop = currentScrollY <= 0;
			const isBottom =
				targetRef.scrollHeight - Math.floor(targetRef.scrollTop) <
				targetRef.clientHeight + 4;

			if (Math.abs(currentScrollY - prevScrollY.current) < 10) {
			} else if (currentScrollHeight != prevScrollHeight.current) {
				//Empty check when height of scroll is changed to do nothing
			} else if (
				(currentScrollY >= 0 && currentScrollY <= 10) ||
				isOnTop
			) {
				setScrollDirection("on-top");
			} else if (currentScrollY > prevScrollY.current || isBottom) {
				setScrollDirection("down");
			} else if (currentScrollY < prevScrollY.current) {
				setScrollDirection("up");
			}
			prevScrollY.current = currentScrollY;
			prevScrollHeight.current = currentScrollHeight;
		}
	};

	useEffect(() => {
		if (targetRef != null) {
			targetRef.addEventListener("scroll", handleScroll);

			return () => {
				targetRef?.removeEventListener("scroll", handleScroll);
			};
		}
	}, [targetRef]);

	useEffect(() => {
		if (targetRef != null) {
			const currentScrollY = targetRef.scrollTop;

			if (currentScrollY < 10) {
				setScrollDirection("on-top");
			}
		}
	}, [pathname]);

	return {
		scrollDirection,
		setShouldApplyHeaderClass,
	};
};
